<template>
  <v-container fluid class="px-10 py-6">
    <!-- Encabezado -->
    <v-row class="my-6" align="center" justify="space-between">
      <v-col cols="12" md="6">
        <div style="font-family: 'montserrat-bold'; font-size: 28px; color: primary;">
          Compliance - KYC Documents
        </div>
        <div style="font-family: 'montserrat-regular'; font-size: 14px;">
          Administra tus documentos requeridos para validación KYC.
        </div>
      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-end">
        <v-card
          class="py-4 px-6"
          style="background-color: #f5f5f5; border-radius: 24px; width: 100%; max-width: 550px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);"
        >
          <div style="overflow: hidden; border-radius: 100px;">
            <v-progress-linear
              :value="porcentajeCumplido"
              height="8"
              color="primary"
              background-color="#dcdcdc"
              rounded
            />
          </div>
          <div class="d-flex justify-space-between align-center" style="flex-wrap: wrap;">
            <div style="font-family: 'montserrat-semibold'; font-size: 14px; white-space: nowrap;">Documentos aprobados</div>
            <div style="font-family: 'montserrat-semibold'; font-size: 14px; white-space: nowrap;">{{ documentos.filter(doc => doc.estatus !== 'pendiente').length + "/" + documentos.length }}</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Secciones dinámicas por categoría -->
    <div class="pa-4" style="background-color: #f4f4f4; border-radius: 24px; box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);">
      <div v-for="(docs, categoria) in documentosAgrupados" :key="categoria" class="mb-10">
        <h2 class="font-weight-bold mb-4" style="font-size: 24px">{{ categoria }}</h2>
        <v-row>
          <v-col v-for="doc in docs" :key="doc.id" cols="12" md="6">
            <v-card outlined class="pa-4" style="background-color: transparent; border: none;">
              <div class="d-flex justify-space-between align-center mb-2">
                <div class="font-weight-bold" style="color: #737583">{{ doc.nombre }}</div>
                <v-chip x-small class="py-3" :color="getColor(doc.estatus)" dark style="text-transform: uppercase; font-family: 'montserrat-bold';">{{ doc.estatus }}</v-chip>
              </div>
              <div class="mb-4 caption">{{ doc.descripcion || 'Documento requerido para validación.' }}</div>
              <div v-if="doc.tipo_input === 'file'">
                <div
                  style="
                    border: 2px dashed #ccc;
                    border-radius: 12px;
                    padding: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #fff;
                  "
                >
                  <div style="display: flex; align-items: center;">
                    <div
                      style="
                        background: #edf3ff;
                        padding: 15px;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 20px;
                      "
                    >
                      <v-icon color="primary" size="32">mdi-cloud-upload</v-icon>
                    </div>
                    <div>
                      <div style="font-size: 14px; font-weight: 500; font-family: 'montserrat-semibold';">Select a file</div>
                      <div style="color: grey; font-size: 12px; font-family: 'montserrat-semibold'">JPG, PNG or PDF, file size no more than 10MB</div>
                    </div>
                  </div>
                  <v-btn
                    outlined
                    rounded
                    color="primary"
                    :disabled="doc.estatus !== 'pendiente' || doc.estatus === 'rechazado'"
                    class="py-1"
                    style="box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.15); font-size: 12px; padding: 8px 16px; border: solid 2px #1976d2; height: fit-content; font-family: 'Montserrat-Bold'; text-transform: none;"
                    @click="triggerFileInput(doc.id)"
                  >
                    Select File
                  </v-btn>

                  <input
                    :ref="'fileInput_' + doc.id"
                    type="file"
                    style="display: none"
                    @change="handleFileUpload"
                  />
                </div>

              </div>

              <div v-else-if="doc.tipo_input === 'text'">
                <v-text-field
                  outlined
                  dense
                  :value="doc.valor"
                  label="Ingresa valor"
                  @change="handleTextInput(doc, $event)"
                />
              </div>

              <div v-if="doc.comentario_admin" class="mt-2">
                <v-alert type="info" dense outlined>
                  Comentario del revisor: {{ doc.comentario_admin }}
                </v-alert>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      documentos: [],
    };
  },
  computed: {
    documentosAgrupados() {
      return this.documentos.reduce((acc, doc) => {
        if (!acc[doc.categoria]) acc[doc.categoria] = [];
        acc[doc.categoria].push(doc);
        return acc;
      }, {});
    },
    porcentajeCumplido() {
      const total = this.documentos.length;
      const completos = this.documentos.filter(doc => doc.estatus !== 'pendiente').length;
      return Math.round((completos / total) * 100);
    }
  },
  methods: {
    getKYCDocuments() {
      this.loading = true;

      DB.get(`${URI}/api/v1/en/compliance/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.documentos = response.data.data;
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      })
      .finally(() => {
        this.loading = false;
      });
    },
    getColor(estatus) {
      switch (estatus) {
        case 'aprobado': return 'green';
        case 'En revision': return 'blue';
        case 'rechazado': return 'red';
        default: return 'grey';
      }
    },
    handleUpload(doc, file) {
      console.log(`Subiendo archivo para ${doc.nombre}`, file);
      // Simulación de subida, aquí se llama POST real
    },
    handleTextInput(doc, valor) {
      console.log(`Valor ingresado en ${doc.nombre}:`, valor);
      // Simulación de guardado, aquí se llama PUT real
    },
    triggerFileInput(id) {
      const ref = this.$refs[`fileInput_${id}`];
      const input = Array.isArray(ref) ? ref[0] : ref;

      if (input && typeof input.click === 'function') {
        input.click();
      } else {
        console.error("No se pudo acceder al input de archivo");
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        console.log("Archivo seleccionado:", file.name);
        // Aquí puedes subirlo o almacenarlo
      }
    }
  },
  mounted() {
    this.getKYCDocuments();
  }
};
</script>

<style scoped>
</style>
